module.exports = __webpack_public_path__ + "new1.02080ccc.png";